<template>
  <div>
    <PageSpinner v-if="loading" />
    <template v-if="email">
      <!-- <div class="btn-add-staff">
        <button @click="sendFcm">SEND FCM</button>
      </div> -->
      <div class="btn-add-staff">
        <router-link :to="{ name: 'add-staff' }">ДОБАВИ СЛУЖИТЕЛ</router-link>
      </div>
    </template>
    <Card :data="staff_members" />
  </div>
</template>

<script>
import Card from "@/components/CardUser";
import { mapState, mapActions } from "vuex";
import PageSpinner from "../components/widgets/PageSpinner";

export default {
  components: {
    Card,
    PageSpinner,
  },
  methods: {
    ...mapActions("staff", ["get_all_staff"]),
    async sendFcm() {
      try {
        await fetch("https://fcm.googleapis.com/fcm/send", {
          method: "POST",
          headers: {
            Authorization: `key=AAAA-bLMga4:APA91bEJ03RTWvFBb9okbM5pqEt8B5pAudoIIf6zw1i81_Uc8S7aqewwquGvXhkq5zVsfFP2EQfAquwvrJW8d0b9wUFkeUvqEGA7q2HYpLRUaxNhbz6GbuRaEswOdpvSV5jLI-Rvc7hD`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            to: "dreoNTocTpJu5Ft5VNwVF4:APA91bHL1dLc_iyo-4UrcKPmqEKq_5Pq5CLX1lGlsZ3s3FdLFwRQ3iL01GsJ-DA8NHs-rc3Nyy3cZ2raKkW1shz81mt3QiIDnHX1tcanTF0aPuAUf3povY0Lae_wChuwjSaUZHy7Ahsp",
            priority: "high",
            data: {
              fcm_title: "TEST",
              fcm_body: "НОВИ ПРОМОЦИИ",
            },
          }),
        });
      } catch (error) {
        console.log(error);
      }
    },
  },
  created() {
    if (!this.staff_members.length) {
      this.get_all_staff();
    }
  },
  computed: {
    ...mapState("staff", ["staff_members"]),
    ...mapState("user", ["email"]),
    ...mapState("widgets", ["loading"]),
  },
};
</script>

<style scoped lang="scss">
.btn-add-staff {
  background: #fff;
  padding: 1rem;
  margin: 1rem auto;
  display: flex;
  justify-content: center;
  align-items: center;
  a {
    background: chocolate;
    margin: 1rem auto;
    padding: 1rem;
    color: #fff;
    font-size: 1.5rem;
    display: inline-block;
  }
}
</style>
